import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import { Button, Modal, Loading } from '../components/all'
import useAulaStore from '../store/useAulaStore'
import useUserStore from '../store/useUserStore'
import { formatarDataParaExibir } from '../utils/dataFormat'
import { ToastContainer } from 'react-toastify'
import useAula from '../hooks/useAula.js'

export default function Confirm() {
  const { InsertClass, loading } = useAula()

  //#region Lógica
  const { aula } = useAulaStore.getState()
  const { usuario } = useUserStore()
  const instrutor = aula.instrutor
  const veiculo = aula.veiculo
  const type = aula.tipo
  const data = aula.data
  const hora = aula.hora

  const navigate = useNavigate()
  const [date] = useState(data)
  const [modalMessage, setModalMessage] = useState('')
  const [isModalVisible, setModalVisible] = useState(false)

  const toggleModal = (message) => {
    setModalMessage(message)
    setModalVisible(!isModalVisible)
  }

  const handleConfirm = async () => {
    const aula = {
      instrutor_id: instrutor.instrutor_id,
      aluno_id: usuario.usuario_id,
      data: date,
      tipo: type,
      hora: hora,
      veiculo_id: veiculo.veiculo_id,
      autoescola_id: usuario.autoescola_id,
      marcada_por: 1,
      configuracoes: usuario.configuracoes
    }

    const result = await InsertClass(aula)
    if (result.success) {
      navigate('/fim')
    } else {
      toggleModal(result.error)
      return
    }
  }

  const ModalContent = () => (
    <div className="flex flex-col items-center gap-4 text-center">
      <span className="material-icons text-red-600 text-6xl">error</span>
      <div>
        <h1 className="text-xl font-bold">Aviso</h1>
        <p className="text-gray-700 mt-1">{modalMessage}</p>
      </div>

      <Button onClick={() => setModalVisible(false)} className="mt-2" type={3}>
        Ok
      </Button>
    </div>
  )
  //#endregion

  return (
    <div className="flex flex-col px-4 py-6 mx-auto w-full min-h-screen min-h-[100dvh] justify-start sm:justify-center items-center max-w-[800px] gap-6 pb-24">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-800">Confirmar Aula</h1>
        <p className="text-gray-500">Revise os dados antes de finalizar</p>
      </div>

      <div className="bg-white shadow-md rounded-xl p-6 w-full max-w-md space-y-3 border border-gray-200">
        <Info label="Tipo da Aula" value={type} />
        <Info label="Instrutor" value={instrutor.nome_instrutor} />
        <Info label="Data" value={formatarDataParaExibir(date)} />
        <Info label="Hora" value={hora} />
      </div>

      <Loading visible={loading} />

      <Button
        onClick={loading ? null : handleConfirm}
        disabled={loading}
        className="w-full max-w-md"
      >
        {loading ? 'Processando...' : 'Finalizar'}
      </Button>


      <Modal
        isOpen={isModalVisible}
        onConfirm={() => setModalVisible(false)}
        onCancel={() => setModalVisible(false)}
      >
        <ModalContent />
      </Modal>
    </div>
  )
}

function Info({ label, value }) {
  return (
    <div className="flex justify-between items-center border-b last:border-b-0 pb-2">
      <span className="text-gray-600 font-medium">{label}</span>
      <span className="text-gray-900 font-semibold">{value}</span>
    </div>
  )
}
